module.exports = __webpack_public_path__ + "components/discount-pages/roadsurfer/static/roadsurfer-2560-ceb7eb78962bd529405876a12542b8b2.webp";